import { useContext } from 'react';

import { ThemeContext, ThemeProviderValue } from './ThemeProvider';

export const useTheme = () => useContext<ThemeProviderValue>(ThemeContext);
